<template>
  <div class="error-page">
    <div class="error-page-main">
      <div class="error-page-inner">
        <div class="error-title">
          <h4>404</h4>
        </div>
        <div class="error-sub-title">Oops!</div>
        <div class="detailed-description">
          <p>We are sorry,<br />The page you were looking for doesn't exist.</p>
        </div>
        <router-link to="/" title="Home">
          <button>Back to Home</button>
        </router-link>
        <div class="no-data-img">
          <img src="../assets/img/nodata.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
};
</script>

<style scoped>
.error-page {
  height: 100vh;
  text-align: center;
  padding: 50px 0;
  box-sizing: border-box;
  position: relative;
  max-height: 100vh;
  overflow: hidden;
}
.error-page-main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.error-page .error-title h4 {
  font-size: 110px;
  font-weight: 600;
  line-height: 85px;
  margin-bottom: 40px;
  color: #000;
}

.error-page .error-sub-title {
  font-size: 30px;
  color: #404040;
  font-weight: 600;
  margin-bottom: 10px;
}

.error-page .detailed-description p {
  color: #404040;
  margin-bottom: 40px;
}
.error-page-inner a {
  display: block;
}
.error-page-inner button {
  background: transparent;
  border: 1px solid #000;
  border-radius: 4px;
  outline: none;
  padding: 8px 20px;
  color: #000;
  cursor: pointer;
  transition: all 300ms ease-in-out;
}

.error-page-inner button:hover {
  background: #000;
  color: #fff;
}
.error-page-main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.no-data-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  opacity: 0.3;
  box-sizing: border-box;
  text-align: left;
  z-index: -1;
}

.no-data-img img {
  max-width: 100%;
  max-height: 500px;
}
</style>
